import { useContext } from 'react';
import { DaoContext, useSnapshotFunctions } from '../daoHook';
import moment from 'moment';

export const DaoStatusBadge = ({ status }) => {
  return (
    <div className='flex h-fit w-fit rounded-[10px] border border-[#7445FF] bg-[#7445FF] px-[12px] py-[6px] text-[14px] capitalize text-white'>
      {status}
    </div>
  );
};

export const DaoUserIcon = () => {
  return (
    <div className='h-fit w-fit rounded-full bg-[#7445FF] p-3'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
      >
        <g clipPath='url(#clip0_11_72)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M5.35918 5.46409C5.35918 4.40641 6.26106 3.52826 7.39978 3.52826C8.53848 3.52826 9.44038 4.40641 9.44038 5.46409C9.44038 6.52177 8.53848 7.39993 7.39978 7.39993C6.26106 7.39993 5.35918 6.52177 5.35918 5.46409ZM7.39978 3C5.99274 3 4.83093 4.09177 4.83093 5.46409C4.83093 6.83642 5.99274 7.92819 7.39978 7.92819C8.8068 7.92819 9.96863 6.83642 9.96863 5.46409C9.96863 4.09177 8.8068 3 7.39978 3ZM3.57825 12.9021C3.57825 10.6664 5.32184 8.87103 7.45215 8.87103C9.58246 8.87103 11.326 10.6664 11.326 12.9021H11.8543C11.8543 12.137 11.6718 11.4145 11.349 10.7798C11.786 10.3994 12.3472 10.1721 12.9587 10.1721C14.3374 10.1721 15.4717 11.3351 15.4717 12.7906H16C16 11.0621 14.6475 9.64384 12.9587 9.64384C12.2481 9.64384 11.5951 9.89619 11.0785 10.317C10.2861 9.1262 8.96058 8.34277 7.45215 8.34277C5.96471 8.34277 4.6551 9.10456 3.85912 10.2675C3.35284 9.8765 2.72365 9.64384 2.04131 9.64384C0.352453 9.64384 -1 11.0621 -1 12.7906H-0.471741C-0.471741 11.3351 0.662587 10.1721 2.04131 10.1721C2.62208 10.1721 3.15756 10.3772 3.58434 10.7237C3.2434 11.3718 3.04999 12.1143 3.04999 12.9021H3.57825ZM12.9235 6.58636C12.2034 6.58636 11.6409 7.14059 11.6409 7.79872C11.6409 8.45682 12.2034 9.01107 12.9235 9.01107C13.6436 9.01107 14.2062 8.45682 14.2062 7.79872C14.2062 7.14059 13.6436 6.58636 12.9235 6.58636ZM11.1126 7.79872C11.1126 6.82596 11.9351 6.0581 12.9235 6.0581C13.9119 6.0581 14.7344 6.82596 14.7344 7.79872C14.7344 8.77147 13.9119 9.53933 12.9235 9.53933C11.9351 9.53933 11.1126 8.77147 11.1126 7.79872ZM2.07648 6.58636C2.79658 6.58636 3.35913 7.14059 3.35913 7.79872C3.35913 8.45682 2.79658 9.01107 2.07648 9.01107C1.35635 9.01107 0.79381 8.45682 0.79381 7.79872C0.79381 7.14059 1.35635 6.58636 2.07648 6.58636ZM3.88738 7.79872C3.88738 6.82596 3.0649 6.0581 2.07648 6.0581C1.08803 6.0581 0.265551 6.82596 0.265551 7.79872C0.265551 8.77147 1.08803 9.53933 2.07648 9.53933C3.0649 9.53933 3.88738 8.77147 3.88738 7.79872Z'
            fill='white'
            stroke='white'
            strokeWidth='0.5'
          />
        </g>
        <defs>
          <clipPath id='clip0_11_72'>
            <rect width='16' height='16' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

const DaoItem = ({ proposal }) => {
  const { title, body, start, end, state } = proposal;
  const { selectProposal } = useSnapshotFunctions();

  return (
    <>
      <div className='flex'>
        <DaoStatusBadge status={state} />
        <div className='mx-4 mt-4'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
          >
            <circle cx='6' cy='6' r='5.5' fill='#7445FF' fillOpacity='0.6' stroke='#7445FF' />
          </svg>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='2'
            height='89'
            viewBox='0 0 2 89'
            fill='none'
            className='ml-[5px]'
          >
            <path d='M1 0L0.999996 89' stroke='#7445FF' strokeDasharray='3 3' />
          </svg>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
          >
            <circle cx='6' cy='6' r='5.5' stroke='#7445FF' />
          </svg>
        </div>
        <div className='relative flex items-center'>
          <DaoUserIcon />
          <span className='ml-6 text-[16px] font-semibold text-[#000] dark:text-white'>
            {title}
          </span>
          <div className='absolute bottom-0 min-w-[200px] font-normal text-[#7D7F94] dark:text-white dark:opacity-70'>
            Ends
            {new Date(end * 1000).toString()?.substr(3, 18)}
          </div>
        </div>
        <div
          className='ml-auto flex cursor-pointer items-center text-[16px] font-normal text-[#666]'
          onClick={() => selectProposal(proposal)}
        >
          <span className='hidden dark:text-white md:block'>Cast Your Vote </span>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='10'
            height='17'
            viewBox='0 0 10 17'
            fill='none'
            className='ml-4'
          >
            <path
              d='M1 0.5L9 8.5L1 16.5'
              className='stroke-[#666666] dark:stroke-white'
              strokeLinecap='round'
            />
          </svg>
        </div>
      </div>
      <div className='my-8 h-[1px] w-full bg-[#E7E8EC]' />
    </>
  );
};

export const DaoList = () => {
  const { daoData, onDaoUpdate } = useContext(DaoContext);

  const { proposals } = daoData;
  return (
    <div className='w-full'>
      <div className='my-8 h-[1px] w-full bg-[#E7E8EC]' />
      {proposals &&
        proposals.map((proposal) => {
          return <DaoItem proposal={proposal} key={proposal.id + 'proposal'} />;
        })}
      {/*<DaoItem />
      <DaoItem />
    <DaoItem />*/}
    </div>
  );
};
